import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AdvertiserInfoVO } from '../../../interfaces/AdvertiserInfo';
import { BudgetingService } from '../../../services/budgeting.service';
import { PlannerConstants } from 'src/app/planner/constants/planner.const';
import { getDateAfterNDays } from 'src/app/util/util';

@Component({
  selector: 'flight-schedule',
  templateUrl: './flight-schedule.component.html',
  styleUrls: ['./flight-schedule.component.scss']
})
export class FlightScheduleComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() isNew: boolean;
  @Input() advertiserInfo: AdvertiserInfoVO;
  readonly budgetLimit = PlannerConstants.BUDGET_LIMIT;

  // Datepicker will have form control in the format of { date: TimeStamp, allDay: boolean }, cannot use start/end date form control directly
  selectedStartDate: FormControl = new FormControl({});
  selectedEndDate: FormControl = new FormControl({});
  currencySymbol: string = '';
  maxDate: Date;

  constructor(private budgetingService: BudgetingService) { }

  ngOnInit() {
    if (!this.isNew && this.advertiserInfo.marketTimeZone) {
      this.selectedStartDate.patchValue({ date: this.budgetingService.convertFromLocalTime(this.startDate.value, this.advertiserInfo.marketTimeZone, 'startDate').getTime() / 1000 });
      this.selectedEndDate.patchValue({ date: this.budgetingService.convertFromLocalTime(this.endDate.value, this.advertiserInfo.marketTimeZone, 'endDate').getTime() / 1000 });
    }
    if (this.group.disabled) {
      this.selectedStartDate.disable();
      this.selectedEndDate.disable();
    }
    if (this.advertiserInfo.currency) {
      this.currencySymbol = this.budgetingService.getCurrencyAbbrevWithSymbol(this.advertiserInfo.currency);
    }
    //Start Date and End Date can not be more than 3 months in future
    this.maxDate = getDateAfterNDays(89, this.advertiserInfo.marketTimeZone);
  }

  setStartDate(event) {
    let localDate = this.budgetingService.convertToLocalTime(event.date * 1000, this.advertiserInfo.marketTimeZone, 'startDate');
    this.startDate.patchValue(localDate);
    if (!this.startDate.touched) {
      this.startDate.markAsTouched();
    }
  }

  setEndDate(event) {
    let localDate = this.budgetingService.convertToLocalTime(event.date * 1000, this.advertiserInfo.marketTimeZone, 'endDate');
    this.endDate.patchValue(localDate);
    if (!this.endDate.touched) {
      this.endDate.markAsTouched();
    }
  }

  get startDate(): FormControl {
    return this.group.get('startDate') as FormControl;
  }

  get endDate(): FormControl {
    return this.group.get('endDate') as FormControl;
  }

  get spendingCap(): FormControl {
    return this.group.get('spendingCap') as FormControl;
  }
}
